module.exports = __webpack_public_path__ + "media/src/public/img/payment/sber-button-g-b-09ff027d6e1d11e929ccf568f2b5c77f.svg";